import { EditOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Input, Popover, Space, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'

/**
 * O ghi chu dang text trong bang quan ly viec (cot Note1).
 *
 * Giong JobLinkCell nhung giu nguyen van ban (khong tach link, khong chuan hoa
 * URL). O hep nen chi hien 2 dong, di chuot vao de xem day du. Bam but de mo
 * popover sua, Ctrl+Enter de luu.
 */

const MAX_LENGTH = 5000

type JobNoteCellProps = {
   value?: string
   onSave: (value: string) => Promise<boolean>
   placeholder?: string
   title?: string
}

const JobNoteCell: React.FC<JobNoteCellProps> = ({ value, onSave, placeholder, title }) => {
   const { t } = useTranslation()
   const [open, setOpen] = useState(false)
   const [draft, setDraft] = useState('')
   const [isSaving, setIsSaving] = useState(false)
   const text = typeof value === 'string' ? value : ''

   // Mo popover thi nap lai noi dung dang luu
   useEffect(() => {
      if (open) setDraft(text)
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [open])

   const handleSave = async () => {
      try {
         setIsSaving(true)
         const ok = await onSave(draft.trim())
         if (ok) setOpen(false)
      } finally {
         setIsSaving(false)
      }
   }

   const editForm = (
      <div style={{ width: 420 }}>
         <div style={{ marginBottom: 8, color: '#8c8c8c', fontSize: 12 }}>{'Ctrl + Enter để lưu.'}</div>
         <Input.TextArea
            autoFocus
            value={draft}
            rows={4}
            maxLength={MAX_LENGTH}
            onChange={(e) => setDraft(e.target.value)}
            onKeyDown={(e) => {
               if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
                  e.preventDefault()
                  handleSave()
               }
            }}
            placeholder={placeholder}
         />
         <Space style={{ marginTop: 8, display: 'flex', justifyContent: 'flex-end' }}>
            <Button size="small" onClick={() => setOpen(false)}>
               {t(GLOBAL_CLIENT.huy)}
            </Button>
            <Button size="small" type="primary" loading={isSaving} onClick={handleSave}>
               {t(GLOBAL_CLIENT.save)}
            </Button>
         </Space>
      </div>
   )

   return (
      <div className="job-link-cell">
         {text === '' ? (
            <span style={{ color: '#b0b0b0' }}>{'—'}</span>
         ) : (
            <Tooltip title={text} overlayStyle={{ whiteSpace: 'pre-line', maxWidth: 420 }}>
               <span className="txtMax2Line" style={{ whiteSpace: 'pre-line' }}>
                  {text}
               </span>
            </Tooltip>
         )}
         <Popover
            visible={open}
            onVisibleChange={setOpen}
            trigger="click"
            placement="bottomRight"
            title={title}
            content={editForm}
            destroyTooltipOnHide
         >
            <span className="job-link-cell__edit gx-link" title={title}>
               {text === '' ? <PlusOutlined /> : <EditOutlined />}
            </span>
         </Popover>
      </div>
   )
}

export default JobNoteCell
